import { db } from "../firebase-config";
import { collection, setDoc, deleteDoc, query, doc, addDoc, onSnapshot } from "firebase/firestore";


export const organizationInventoryLocationListener = (organization, onLocationsUpdate) => {
  const locationsQuery = query(collection(db, "organizations", organization, "locations"))
  const unsubscribe = onSnapshot(locationsQuery, (querySnapshot) => {
      const locationItems = [];
      querySnapshot.forEach((doc) => {
        locationItems.push({ id: doc.id, ...doc.data() });
      });
      onLocationsUpdate(locationItems);
  })
  return () => unsubscribe()    
}

export const locationSnapshotListener = (organization, id, onLocationUpdate) => {
    const locationsDocRef = doc(db, "organizations", organization, "locations", id);

    const unsubscribe = onSnapshot(locationsDocRef, (docSnapshot) => {
        if (docSnapshot.exists()) {
            onLocationUpdate({ id: docSnapshot.id, ...docSnapshot.data() });
        } else {
            onLocationUpdate(null);
        }
    });
    return unsubscribe;
};

// Add a new location
export const addLocation = async (organization, location) => {
    try {
        const locationsRef = collection(db, "organizations", organization, "locations"); 
        await addDoc(locationsRef, { name: location });
        return { success: true, error: null };
    } catch (error) {
        console.error("Error adding location:", error);
        return { success: false, error: error.message || `Failed to add ${location}` };
    }
};

// Update an existing location
export const updateLocations = async (organization, location) => {
    try {
        const locationRef = doc(db, "organizations", organization, "locations", location.id);
        await setDoc(locationRef, location, { merge: true });
        return { success: true, error: null };
    } catch (error) {
        console.error("Error updating location:", error);
        return { success: false, error: error.message || `Failed to update ${location.name}` };
    }
};

export const deleteLocation = async (organization, locationId) => {
    try {
        const locationRef = doc(db, "organizations", organization, "locations", locationId);
        await deleteDoc(locationRef);
        return { success: true, error: null };
    } catch (error) {
        console.error("Error deleting location:", error);
        return { success: false, error: error.message || 'Failed to delete location' };
    }
};